import { MobileTabModel } from './mobile-tab.model';

export class MobileTabsModel {
    PageTitle: string;
    Tabs: MobileTabModel[] = [];
    SelectedIndex = 0;
    constructor(pageTitle?: string) {
        this.PageTitle = pageTitle || '';
    }

    IsShownInMobileTab(tabName) {
        return this.Tabs[this.SelectedIndex].PropertyName == tabName ? 'ShownInMobileTab' : '';
    }
}
